/**
 * NotificationsWrapper.jsx
 * Created by Jon Lin on 3/5/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Notice from './Notice';

const propTypes = {
    noticeType: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element
    ]),
    closeButton: PropTypes.bool
};

export default class NotificationWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showNotice: true
        };

        this.closeNotice = this.closeNotice.bind(this);
    }

    closeNotice() {
        this.setState({
            showNotice: false
        });
    }

    render() {
        return (
            <div>
                <Notice
                    showNotice={this.state.showNotice}
                    showClose={this.props.closeButton}
                    closeNotice={this.closeNotice}
                    noticeType={this.props.noticeType}>
                    {this.props.children}
                </Notice>
            </div>
        );
    }
}

NotificationWrapper.propTypes = propTypes;
NotificationWrapper.defaultProps = {
    closeButton: true
};
